import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEmployee } from 'src/app/company/models/employee';
import { environment } from 'src/environments/environment';
import { IRefreshTokenRequest, ISignInUserRequest, ITokenResponse } from '../models/token';


@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private http: HttpClient) {}

  signIn(request: ISignInUserRequest, tenantId : string){

    return this.http.post<ITokenResponse>(
      `${environment.baseUrl}/tokens`,
      request,
      {
        withCredentials: true,
        headers: new HttpHeaders({'tenant' : tenantId}) 
      }
    )
  }

  getUser(){
    return this.http.get<IEmployee>(
      `${environment.baseUrl}/personal/profile`
    )
  }

  refreshToken(request : IRefreshTokenRequest, companyId: string){
    return this.http.post<ITokenResponse>(
      `${environment.baseUrl}/tokens/refresh`,
      request,
      {
        withCredentials: true,
        headers: new HttpHeaders({'tenant' : companyId}) 
      }
    )
  }
}
